import { xhrFetch } from "../xhrManager";

export default class AISApi {
    constructor() {
        this.apiUrl = this.getApiUrl();
    }

    getApiUrl() {
        let apiUrl = "https://ais.lucchese.com";
        if (window.location.host === "lucchese-staging.myshopify.com") {
            apiUrl = "https://ais-staging.lucchese.com";
        }

        return apiUrl;
    }

    async getAisData(variantId, parameters = [], successCallback = null, errorCallback = null, finallyCallback = null) {
        return variantId
            ? await xhrFetch(
                  `${this.apiUrl}/inventory/${variantId}${parameters.filter((n) => n).length > 0 ? "?" + parameters.filter((n) => n).join("&") : ""}`,
                  {
                      method: "GET",
                  },
                  successCallback ? successCallback : () => {},
                  errorCallback ? errorCallback : () => {},
                  finallyCallback ? finallyCallback : () => {}
              )
            : {};
    }
}
